import { Component, signal, WritableSignal } from '@angular/core';
import { PermissionService } from '../../../modules/buildings-shared/services/permission.service';
import { MarkdownComponent } from 'ngx-markdown';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-service-conditions',
  imports: [MarkdownComponent, RouterLink],
  templateUrl: './service-conditions.html',
  styleUrl: './service-conditions.scss',
})
export class ServiceConditions {

    permissionService: WritableSignal<PermissionService | undefined> = signal<PermissionService | undefined>(undefined);

    constructor(permissionService: PermissionService) {
        this.permissionService.set(permissionService);
    }

}
